import { useTranslation } from "react-i18next";

import { TableHeader } from "@/components/Layout/Table/TableHeader/TableHeader";
import { SortableHeaderCell } from "@/components/Layout/Table/TableSortButton/TableSortButton";
import { GetEvnForCustomerSortField } from "@/services/model";

import { EvnSelectAllCheckbox } from "./EvnSelectAllCheckbox";

// this is the table header row for the itemized bill (EVN) overview
export const ItemizedBillOverviewHeader = ({
  currentPageItemizedBillIds,
  isSelecting,
}: {
  currentPageItemizedBillIds: string[];
  isSelecting?: boolean;
}) => {
  const { t } = useTranslation(["portal", "translation"]);

  return (
    <TableHeader>
      {/* Unlike the bills table, the checkbox column is added ahead of the
          data columns rather than swapped - both are visible at once while
          selecting. */}
      {isSelecting && (
        <th className="evn-selection">
          <EvnSelectAllCheckbox
            currentPageItemizedBillIds={currentPageItemizedBillIds}
          />
        </th>
      )}
      <th>{t("common.phoneNumber")}</th>
      <SortableHeaderCell
        title={t("translation:Common.label.period")}
        sortField={GetEvnForCustomerSortField.Datum}
      />
      <SortableHeaderCell
        title={t("bills.list.tableHeaders.amount")}
        sortField={GetEvnForCustomerSortField.Betrag}
      />
      <th>{t("bills.list.tableHeaders.number")}</th>
      <th>{t("bills.list.tableHeaders.open")}</th>
    </TableHeader>
  );
};
